{
  "title": "GRN Label Print",
  "subtitle": "Select a GRN, then an item on it, then print — the label updates automatically as the item changes.",
  "tabs": {
    "print": "Print",
    "reprint": "Reprint"
  },
  "modeBeforeQc": "Print-before-QC mode: any item on the GRN can be printed now, up to its received quantity. QC for an item can only be submitted after its label has been printed at least once.",
  "modeAfterQc": "Print-after-QC mode: an item can only be printed once its QC has passed (or was never required), up to its QC-accepted quantity.",
  "selectionCriteria": "Selection Criteria",
  "selectGrn": "GRN Number",
  "selectItem": "Item",
  "noItemsOnGrn": "This GRN has no lines.",
  "awaitingQc": "awaiting QC",
  "selectTemplate": "Label Template",
  "noTemplatesAvailable": "No templates available for this item — design one in Label Designer.",
  "itemDetails": "Item Details",
  "itemFields": {
    "batchNo": "Batch No",
    "receivedQty": "Received Qty",
    "acceptedQty": "QC-Accepted Qty",
    "labelPrintedQty": "Already Printed Qty"
  },
  "configuration": "Print Configuration",
  "labelQuantity": "Quantity",
  "maxQuantityHint": "Up to {{max}} available for this item.",
  "mode": {
    "auto": "Auto",
    "manual": "Manual",
    "autoHint": "Splits the remaining {{total}} units into labels of {{stuffingQty}} each (from this material's Stuffing Qty), with the last label covering the remainder.",
    "autoNoStuffingQty": "No Stuffing Qty (or a Stuffing Qty of 1) is set on this material — printing one label per unit ({{total}} labels).",
    "labelN": "Label {{n}}",
    "addLabel": "Split / Add Label",
    "allocatedOf": "Allocated: {{allocated}} of {{total}}",
    "mismatchHint": "The split must add up to exactly {{total}} before printing."
  },
  "sendingToPrinter": "Preparing...",
  "printLabels": "Print {{count}} Label(s)",
  "canvasPreviewTitle": "Label Preview",
  "selectTemplatePrompt": "Select a GRN, item, and template to preview the label.",
  "noLabelsToPreview": "Set a valid quantity split above to preview the labels.",
  "sampleMaterial": "Sample Material",
  "history": {
    "title": "Recent Print History",
    "date": "Date",
    "grn": "GRN #",
    "material": "Material",
    "template": "Template",
    "quantity": "Qty",
    "printer": "Printer/Station",
    "user": "Printed By"
  },
  "reprint": {
    "selectionCriteria": "Select GRN & Item",
    "noPrintedGrns": "No GRNs have any printed labels yet.",
    "noPrintedItems": "No items on this GRN have been printed yet.",
    "noHistory": "No labels have been printed yet for this item.",
    "labelCount": "Labels",
    "reprintButton": "Reprint"
  }
}
